import { LOCALSTORAGE_ITEMS } from "../constants";
import eventsService, { EVENTS } from "services/events";
import localStorageService from "services/localStorage";
import { actions } from "store/microphone";

export const { microphoneSet, microphoneSetAvailable, microphoneSetRecording } =
  actions;

export const microphoneChange = (
  micId,
  micName,
  saveToLS = true,
  track = true
) => {
  return async (dispatch) => {
    if (saveToLS) {
      localStorageService.setItem(LOCALSTORAGE_ITEMS.microphone.id, micId);
      localStorageService.setItem(LOCALSTORAGE_ITEMS.microphone.name, micName);
    }
    dispatch(microphoneSet({ micId, micName }));
    if (track) {
      eventsService.track(EVENTS.CHANGE_MIC);
    }
  };
};
